import { useEffect, useState } from 'react';
import { giftsSidesheetWordings } from '@/constants/gifts';
import { useTranslations } from 'next-intl';

export default function useGiftDeliveryOptions(config, selectedIndex) {
  const [deliveryOptions, setDeliveryOptions] = useState(null);
  const t = useTranslations('gifts');

  useEffect(() => {
    if (config && config?.giftOrder?.enabled) {
      const _deliveryOptions = config?.giftOrder?.deliveryOptions?.options?.map(option => {
        return {
          ...option,
          selected: option.index === (selectedIndex && selectedIndex > -1 ? selectedIndex : 0),
          title: t(`aside.${option.type}.title`),
          subtitle: t(`aside.${option.type}.subtitle`),
        };
      });

      setDeliveryOptions(_deliveryOptions || []);
    }
  }, [config, selectedIndex]);

  return { deliveryOptions };
}
